export async function downloadTrackAudio(audioUrl: string, title: string, format: "mp3" | "wav"): Promise<void> {
    const proxyUrl = `/api/proxy-audio?url=${encodeURIComponent(audioUrl)}`
    const response = await fetch(proxyUrl)
    if (!response.ok) throw new Error(`Fetch failed: ${response.status}`)
    const arrayBuffer = await response.arrayBuffer()
    if (format === "wav") {
        const audioCtx = new AudioContext()
        const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer.slice(0))
        const wavBytes = encodeWav(audioBuffer)
        await audioCtx.close()
        triggerDownload(wavBytes, `${sanitizeFilename(title)}.wav`, "audio/wav")
    } else {
        triggerDownload(arrayBuffer, `${sanitizeFilename(title)}.mp3`, "audio/mpeg")
    }
}

function encodeWav(buffer: AudioBuffer): ArrayBuffer {
    const channels = buffer.numberOfChannels
    const sampleRate = buffer.sampleRate
    const frames = buffer.length
    const blockAlign = channels * 2
    const dataSize = frames * blockAlign
    const out = new ArrayBuffer(44 + dataSize)
    const view = new DataView(out)
    const str = (off: number, s: string) => { for (let i = 0; i < s.length; i++) view.setUint8(off + i, s.charCodeAt(i)) }
    str(0, "RIFF"); view.setUint32(4, 36 + dataSize, true); str(8, "WAVE")
    str(12, "fmt "); view.setUint32(16, 16, true); view.setUint16(20, 1, true)
    view.setUint16(22, channels, true); view.setUint32(24, sampleRate, true)
    view.setUint32(28, sampleRate * blockAlign, true); view.setUint16(32, blockAlign, true)
    view.setUint16(34, 16, true); str(36, "data"); view.setUint32(40, dataSize, true)
    let off = 44
    for (let i = 0; i < frames; i++) {
        for (let ch = 0; ch < channels; ch++) {
            const s = Math.max(-1, Math.min(1, buffer.getChannelData(ch)[i]))
            view.setInt16(off, s * 0x7FFF, true)
            off += 2
        }
    }
    return out
}

function triggerDownload(buffer: ArrayBuffer, filename: string, mimeType: string): void {
    const blob = new Blob([buffer], {type: mimeType})
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}

function sanitizeFilename(name: string): string {
    return name.replace(/[/\\:*?"<>|]/g, "_").substring(0, 80)
}
